module.exports = __webpack_public_path__ + "img/banner_industry_m.91f646e1.jpg";